module.exports = "/images/feature-smart-tagging-icon.svg?48cbbe38be27359adc8bf90d45322072";